import store from '@/store'

const onlyRolePage = [
  { name: '地图预警', page: 'dispatch_map', query: { type: 'warning' } },
  { name: '地图车辆', page: 'dispatch_map', query: { type: 'car_search' } }
]

export const queryParse = (queryStr) => {
  let query = {}
  if (queryStr) {
    queryStr.split('&').forEach(v => {
      let i = v.split('=')
      if (i.length === 2) {
        query[i[0]] = i[1]
      }
    })
  }
  return query
}

export const queryCheck = (query1, query2) => {
  if (typeof query1 !== 'object' || typeof query2 !== 'object') {
    return false
  }
  let q1Key = Object.keys(query1)
  let q2Key = Object.keys(query2)
  if (q1Key.length !== q2Key.length) {
    return false
  }
  for (let i of q1Key) {
    if (!q1Key.includes(i)) {
      return false
    }
    if (query1[q1Key] !== query2[q2Key]) {
      return false
    }
  }
  return true
}

export const getPageByMenu = () => {
  let availableMenus = store.getters.availableMenus
  let goMenu = null
  if (availableMenus && availableMenus.length > 0) {
    goMenu = availableMenus[0]
    if (!goMenu.url && goMenu.children && goMenu.children.length > 0) {
      goMenu = goMenu.children[0]
      if (!goMenu.url && goMenu.children && goMenu.children.length > 0) {
        goMenu = goMenu.children[0]
      }
    }
  }
  if (goMenu && goMenu.url) {
    if (goMenu.type === 'sys_page') {
      let m = goMenu.url.split('?')
      let query = m.length === 2 ? queryParse(m[1]) : {}
      return { name: m[0], query: query }
    } else if (goMenu.type === 'out_page') {
      store.dispatch('setOutPageUrl', goMenu.url)
      return { name: 'business.out_page' }
    } else {
      return {name: goMenu.url}
    }
  } else {
    return { name: 'home' }
  }
}

export const geyPageByRole = (routerTo) => {
  // 只能查看指定的页面的角色
  let item = onlyRolePage.find(v => v.name === store.getters.currentRole.name)
  if (item) {
    if (item.page !== routerTo.name || !queryCheck(item.query, routerTo.query)) {
      return {pass: false, router: getPageByMenu()}
    }
  }
  return {pass: true, router: null}
}



// WEBPACK FOOTER //
// ./src/router/role_page.js